import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import TimePicker from "rc-time-picker";

import { MIN_TIME, TIME_FORMAT } from "../../_constants";
import { TimeHelper } from "../../_helpers";
import ToolTipWrapper from "../../_components/ToolTipWrapper";

type CheckInOutFieldsProps = {
    checkIn: string;
    checkOut: string;
    onChangeCheckIn: (value: string) => void;
    onChangeCheckOut: (value: string) => void;
    readOnly?: boolean;
};

// Shared by the PMS integration forms so check-in/check-out look and behave the
// same everywhere: side by side, label above the picker.
export function CheckInOutFields({
    checkIn,
    checkOut,
    onChangeCheckIn,
    onChangeCheckOut,
    readOnly = false,
}: CheckInOutFieldsProps) {
    const { t } = useTranslation();
    const timeNoSecondsFormat = TimeHelper.getTimeFormats().TIME_NO_SECONDS;
    const asMoment = useCallback(
        (time: string) => moment(time, timeNoSecondsFormat),
        [timeNoSecondsFormat],
    );

    return (
        <div className="col-span-full d-flex" style={{ gap: "16px" }}>
            <div className="flex-grow-1">
                <ToolTipWrapper tooltip={t("mod_integrations_check_in_tooltip")}>
                    <label className="font-weight-bold mb-1 d-block">Check In</label>
                </ToolTipWrapper>
                <TimePicker
                    disabled={readOnly}
                    showSecond={false}
                    minuteStep={5}
                    value={asMoment(checkIn)}
                    format={TIME_FORMAT}
                    onChange={(value) =>
                        onChangeCheckIn(value ? value.format(TIME_FORMAT) : MIN_TIME)
                    }
                />
            </div>
            <div className="flex-grow-1">
                <ToolTipWrapper tooltip={t("mod_integrations_check_out_tooltip")}>
                    <label className="font-weight-bold mb-1 d-block">Check Out</label>
                </ToolTipWrapper>
                <TimePicker
                    disabled={readOnly}
                    showSecond={false}
                    minuteStep={5}
                    value={asMoment(checkOut)}
                    format={TIME_FORMAT}
                    onChange={(value) =>
                        onChangeCheckOut(value ? value.format(TIME_FORMAT) : MIN_TIME)
                    }
                />
            </div>
        </div>
    );
}
